import axios from "axios";

export function getSettings(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Settings/getlist", config);
}

export function updateFormStatus(data) {
  const config = {
    params: data,
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Settings/updateFormStatus", config);
}
